angular.module('shared').filter('friendlyDate', function () {
    return function (inputValue) {
        if (inputValue) {
            var dff = moment().diff(moment(inputValue), "minute");
            if (dff > 0 && dff < 60)
                return moment(inputValue).startOf('minutes').fromNow();
            else
            return moment(inputValue).utc().calendar(undefined, {
                // lastDay: '[Yesterday]',
                // sameDay: '[Today]',
                // nextDay: '[Tomorrow]',
                lastWeek: 'DD/MM/YYYY',
                nextWeek: 'DD/MM/YYYY',
                sameElse: 'DD/MM/YYYY'
            });
        }
        return "";
    };
});
angular.module('shared').filter('friendlyDate2', function () {
    return function (inputValue) {
        if (inputValue) {            
            return moment(inputValue).calendar();
            
            // // for local translation, cannot specific harcoded as it not translte properly
            // return moment(inputValue).calendar(undefined, {
            //     lastDay: '[Yesterday]',
            //     sameDay: '[Today]',
            //     nextDay: '[Tomorrow]',
            //     lastWeek: 'ddd, Do MMMM YYYY',
            //     nextWeek: 'ddd, Do MMMM YYYY',
            //     sameElse: 'ddd, Do MMMM YYYY'
            // });
        }
        return "";
    };
});
angular.module('shared').filter('formatDateLocal', function ($filter,$locale) {
    return function (inputValue, format) {
        if(inputValue) {
            if (format) {
                return moment(inputValue).format(format);    
            }

            return moment(inputValue).format("DD/MM/YYYY");
        }
    };
});
angular.module('shared').filter('formatTimeLocal', function () {
    return function (inputValue) {
        return moment(inputValue).format("HH:mm");
    };
});
angular.module('shared').filter('formatDateTimeLocal', function () {
    return function (inputValue, format) {
        if (inputValue) {
            if (format) {
                return moment(inputValue).format(format);
            }
            return moment(inputValue).format('DD/MM/YYYY HH:mm');
        }

    };
});
angular.module('shared').filter('startEndDate', function () {
    return function (item) {
        var formated = "";
        if(item){
            if(item.StartDate){
                formated =  moment(item.StartDate).format('DD/MM/YYYY');
            }
            if(item.EndDate){
                var endDate =  moment(item.EndDate).format('DD/MM/YYYY');
                formated = formated+" - " +endDate;
            }
            return formated;
        }
        return formated;
        if (inputValue) {
            if (format) {
                return moment(inputValue).format(format);
            }
            return moment(inputValue).format('DD/MM/YYYY HH:mm');
        }

    };
});
